/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, limit: NonNullable<unknown> }} Job_Tracking_Limit_TitleInputs */

const en_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You're tracking ${i?.current}/${i?.limit} jobs`)
};

const de_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du verfolgst ${i?.current}/${i?.limit} Jobs`)
};

const fr_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu suis ${i?.current}/${i?.limit} emplois`)
};

const es_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estás rastreando ${i?.current}/${i?.limit} empleos`)
};

const it_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stai monitorando ${i?.current}/${i?.limit} lavori`)
};

const nl_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je volgt ${i?.current}/${i?.limit} vacatures`)
};

const pl_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Śledzisz ${i?.current}/${i?.limit} ofert pracy`)
};

const fi_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seuraat ${i?.current}/${i?.limit} työpaikkaa`)
};

const da_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du sporer ${i?.current}/${i?.limit} jobs`)
};

const sv_job_tracking_limit_title = /** @type {(inputs: Job_Tracking_Limit_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du spårar ${i?.current}/${i?.limit} jobb`)
};

/**
* | output |
* | --- |
* | "You're tracking {current}/{limit} jobs" |
*
* @param {Job_Tracking_Limit_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const job_tracking_limit_title = /** @type {((inputs: Job_Tracking_Limit_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Tracking_Limit_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_tracking_limit_title(inputs)
	if (locale === "fr") return fr_job_tracking_limit_title(inputs)
	if (locale === "es") return es_job_tracking_limit_title(inputs)
	if (locale === "it") return it_job_tracking_limit_title(inputs)
	if (locale === "nl") return nl_job_tracking_limit_title(inputs)
	if (locale === "pl") return pl_job_tracking_limit_title(inputs)
	if (locale === "fi") return fi_job_tracking_limit_title(inputs)
	if (locale === "da") return da_job_tracking_limit_title(inputs)
	if (locale === "sv") return sv_job_tracking_limit_title(inputs)
	return en_job_tracking_limit_title(inputs)
});